<p>
    This assumption is used to highlight results at your planned retirement age in the 
    “Your results” section.
    </p>